"use client";

import {
  Component,
  MouseEventHandler,
  ReactEventHandler,
  ReactNode,
} from "react";
import { getBackgroundImageValue } from "../../stores/StyleStore";

interface IImageComponentProps {
  src: string;
  alt?: string;
  isBackground?: boolean;
  className?: string;
  onClick?: MouseEventHandler;
  onLoad?: ReactEventHandler;
  onError?: ReactEventHandler;
  children?: ReactNode;
  [key: string]: any;
}

interface IImageComponentState {
  validImage: boolean;
}

export default class ImageComponent extends Component<
  IImageComponentProps,
  IImageComponentState
> {
  static defaultProps = {
    src: "",
    alt: "",
    isBackground: false,
    className: "",
    onClick: () => {},
    onLoad: () => {},
  };

  onError?: ReactEventHandler;

  constructor(props: IImageComponentProps) {
    super(props);
    this.state = {
      validImage: true,
    };
  }

  render() {
    if (!this.props.onError) {
      this.onError = () => {
        this.setState({ validImage: false });
      };
    } else {
      this.onError = this.props.onError;
    }
    const { alt, isBackground, className, ...restProps } = this.props;

    let image;
    if (this.props.src === "") {
      image = <></>;
    } else if (isBackground) {
      image = (
        <div
          onClick={this.props.onClick}
          {...restProps}
          style={getBackgroundImageValue(this.props.src)}
          className={className}
          role={alt?.trim() ? "img" : undefined}
          aria-label={alt?.trim() || undefined}
        >
          {this.props.children}
        </div>
      );
    } else if (this.state.validImage) {
      image = (
        <img
          loading={"lazy"}
          onLoad={this.props.onLoad}
          onClick={this.props.onClick}
          {...restProps}
          src={this.props.src}
          className={className}
          alt={alt}
          onError={this.onError}
        />
      );
    }

    return image;
  }
}
